import { defineComponent as l, computed as s, openBlock as n, createElementBlock as c, normalizeClass as d, renderSlot as p } from "vue";
import { tw as o } from "../../utils/tailwind.js";
const f = /* @__PURE__ */ l({
  name: "RevBackdrop",
  __name: "Backdrop",
  props: {
    backgroundColor: { default: "low" }
  },
  setup(e) {
    const a = e, r = s(() => [
      {
        hi: o`bg-overlay-hi`,
        low: o`bg-overlay-low`
      }[a.backgroundColor],
      o`fixed inset-0`
    ]);
    return (t, m) => (n(), c("div", {
      class: d(r.value),
      "data-test": "backdrop"
    }, [
      p(t.$slots, "default")
    ], 2));
  }
});
export {
  f as default
};
